import request from "@/utils/request";
//获取车辆结构

export function VehicleStructure(data) {
  return request({
    url: "/api/Mall/VehicleStructure",
    method: "post",
    data,
  });
}
//获取品牌/车系/车组/车型
export function BrandFamilyGroupType(data) {
  return request({
    url: "/api/Mall/BrandFamilyGroupType",
    method: "post",
    data,
  });
}
